import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';

import type { User } from '@sb/remote-control/types';
import type { ToastState } from '@sb/ui/components';

interface AuthState {
  settings?: User.ConvertedResponse | null;
  toast: {
    state: ToastState | null;
    set: Dispatch<SetStateAction<ToastState | null>>;
  };
  visualizerChildren: {
    state: Record<string, React.ReactNode>;
    set: Dispatch<SetStateAction<Record<string, React.ReactNode>>>;
  };
  userID?: string | null;
}

export default createContext<AuthState>({
  settings: undefined,
  toast: { state: null, set: () => {} },
  visualizerChildren: { state: {}, set: () => {} },
  userID: undefined,
});
